// モフトレチェックモジュール.
import * as Enumerable from 'linq';
import { TUGTableSeconds, TUGTable, BalanceTable, BalanceTableSeconds } from '../constants/MoffCheck';

module MoffCheckUtil {
  /**
   * TUGを年月でユニークにして、一番時間が短いものを選定する.
   *
   * @param {TUGTable[]} items
   * @returns {{[index: string]: TUGTableSeconds; }}
   */
  export let convertTUG = (items: TUGTable[]): {[index: string]: TUGTableSeconds; } => {
    // 結果(日付: 6つの秒).
    const dic: {[index: string]: TUGTableSeconds; } = {}; 
    Enumerable.from(items).where((item: TUGTable) => {
      // 値が"YYYY-MM-DD"かをチェック.
      const regex = /\d{4}-\d{2}-\d{2}/;
      return (item.started_at.match(regex) !== null);
    }).select((item: TUGTable) => {
      // console.log(item);
      const regex = /(\d{4}-\d{2})-\d{2}/;
      let res = item.started_at.match(regex);
      if (res === null) {
        return '-';
      }

      // 0はマッチ全体, 1はグループ化(正規表現でのyyyy-mmが格納されている).
      const yearMonthKey = `${res[1]}`;

      // 最小.
      if (dic[yearMonthKey] === undefined) {
        // 時間.
        dic[yearMonthKey] = {
          time: item.time,
          // 6項目.
          stand_up: item.stand_up,
          in: item.in,
          in_turn: item.in_turn,
          out: item.out,
          out_turn: item.out_turn,
          sit: item.sit,
        } as TUGTableSeconds;
      } else if (dic[yearMonthKey].time > item.time) {
        // 時間.
        dic[yearMonthKey].time = item.time;
        // 6項目.
        dic[yearMonthKey].stand_up = item.stand_up;
        dic[yearMonthKey].in = item.in;
        dic[yearMonthKey].in_turn = item.in_turn;
        dic[yearMonthKey].out = item.out;
        dic[yearMonthKey].out_turn = item.out_turn;
        dic[yearMonthKey].sit = item.sit;
      }

      return yearMonthKey;
    }).toArray();
   
    return dic;
  };

  /**
   * TUGを年月でユニークにして、一番時間が短いものを選定する.
   *
   * @export
   * @param {BalanceTable[]} items
   * @returns {{[index: string]: BalanceTableSeconds; }}
   */
  export let convertBalance = (items: BalanceTable[]): {[index: string]: BalanceTableSeconds; } => {
    // 結果(日付: 時間).
    const dic: {[index: string]: BalanceTableSeconds; } = {}; 
    Enumerable.from(items).where((item: BalanceTable) => {
      // 値が"YYYY-MM-DD"かをチェック.
      const regex = /\d{4}-\d{2}-\d{2}/;
      return (
        item.started_at.match(regex) !== null
        &&
        // 片足のみ.
        (item.measurement_type === 'left_leg' || item.measurement_type === 'right_leg')
      );
    }).select((item: BalanceTable) => {
      const regex = /(\d{4}-\d{2})-\d{2}/;
      let res = item.started_at.match(regex);
      if (res === null) {
        return '-';
      }

      // 0はマッチ全体, 1はグループ化(正規表現でのyyyy-mmが格納されている).
      const yearMonthKey = `${res[1]}`;

      // 最大.
      if (dic[yearMonthKey] === undefined) {
        dic[yearMonthKey] = {
          time: item.time,
        } as BalanceTableSeconds;
      } else if (dic[yearMonthKey].time < item.time) {
        dic[yearMonthKey].time = item.time;
      }

      return yearMonthKey;
    }).toArray();

    return dic;
  };
}

export default MoffCheckUtil;


// WEBPACK FOOTER //
// ./src/utils/MoffCheckModule.tsx